var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('login-ctrl',{attrs:{"propsList":_vm.propsList},on:{"forgetTextClick":_vm.forgetTextClick,"loginButtonClick":_vm.loginButtonClick,"experienceClick":_vm.experienceClick,"registerTextClick":_vm.registerTextClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f99bef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./third_party/common_app/LoginModule/View/Area/LoginArea.vue
// module id = null
// module chunks = 